"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _Nav = _interopRequireDefault(require("react-bootstrap/Nav"));
var _Navbar = _interopRequireDefault(require("react-bootstrap/Navbar"));
var _NavDropdown = _interopRequireDefault(require("react-bootstrap/NavDropdown"));
var _Utils = require("../Utils");
var _index = _interopRequireDefault(require("../UserWayAccessibilityMenu/index.js"));
require("./Header.css");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RigVedQuotes = /*#__PURE__*/(0, _react.lazy)(() => Promise.resolve().then(() => _interopRequireWildcard(require("../RigvedQuotes/index.js"))));
const CommonHeader = _ref => {
  let {
    headerJsonPath = "",
    aiBrandingJsonPath = "",
    cdnPath = "",
    rigvedQuotePath = "",
    IconColor = "white" // Default color is white
  } = _ref;
  const [showRigVedQuotes, setShowRigVedQuotes] = (0, _react.useState)(false);
  const [navbar, setNavbar] = (0, _react.useState)(false);
  const isMobileOrTabletDevice = (0, _Utils.isMobileOrTablet)();
  const [menuItems, setMenuItems] = (0, _react.useState)([]);
  const [navbarExpanded, setNavbarExpanded] = (0, _react.useState)(false);
  const [hoveredDropdown, setHoveredDropdown] = (0, _react.useState)(null); // State to track hovered dropdown

  const rigVedQuotesRef = (0, _react.useRef)(null); // Reference for RigVedQuotes
  const navbarRef = (0, _react.useRef)(null); // Reference for the Navbar
  const cdnBucketPath = process.env.REACT_APP_CDN || cdnPath;
  const rigvedaQuotePath = process.env.REACT_APP_RIGVED_QUOTES_JSON || rigvedQuotePath;

  // Handle hover events for desktop only
  const handleDropdownHover = (dropdownId, isHovering) => {
    if (!isMobileOrTabletDevice) {
      setHoveredDropdown(isHovering ? dropdownId : null);
    }
  };

  // Toggle dropdown on mobile click
  const handleDropdownClick = dropdownId => {
    if (isMobileOrTabletDevice) {
      setHoveredDropdown(hoveredDropdown === dropdownId ? null : dropdownId);
    }
  };
  (0, _react.useEffect)(() => {
    const headerPath = process.env.REACT_APP_ANGELAI_HEADER_JSON || headerJsonPath;
    _axios.default.get(headerPath).then(response => {
      setMenuItems(response.data);
    }).catch(error => {
      console.error("Error fetching menu data:", error);
    });
  }, []);
  const [links, setLinks] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    const fetchLinks = async () => {
      try {
        const brandingJson = process.env.REACT_APP_ANGELAI_JSON || aiBrandingJsonPath;
        const response = await _axios.default.get(brandingJson);
        setLinks(response.data.current);
      } catch (error) {
        console.error("Error fetching links:", error);
      }
    };
    fetchLinks();
  }, []);

  // Utility function to check if a URL belongs to the angelai.com domain
  const isAngelAiDomain = url => {
    try {
      const domain = new URL(url).hostname;
      return domain.includes("angelai.com");
    } catch (error) {
      return false;
    }
  };
  const renderSubMenu = subItems => {
    return subItems.map(subItem => {
      if (subItem.submenu) {
        return /*#__PURE__*/_react.default.createElement(_NavDropdown.default, {
          title: subItem.id,
          key: subItem.id,
          id: `dropdown-${subItem.id}`,
          onMouseEnter: () => handleDropdownHover(subItem.id, true) // Open on hover for desktop
          ,
          onMouseLeave: () => handleDropdownHover(subItem.id, false) // Close on hover out for desktop
          ,
          onClick: () => handleDropdownClick(subItem.id) // Toggle dropdown on mobile click
          ,
          show: isMobileOrTabletDevice ? hoveredDropdown === subItem.id : hoveredDropdown === subItem.id // Control dropdown visibility on mobile
        }, renderSubMenu(subItem.submenu));
      } else {
        return /*#__PURE__*/_react.default.createElement(_NavDropdown.default.Item, {
          key: subItem.id,
          href: subItem.url,
          target: isAngelAiDomain(subItem.url) ? "_self" : "_blank" // Open in same tab if angelai.com, else new tab
          ,
          rel: isAngelAiDomain(subItem.url) ? "" : "noopener noreferrer" // For security when opening in a new tab
        }, subItem.id);
      }
    });
  };
  (0, _react.useEffect)(() => {
    let prevScrollPos = window.scrollY;
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const Navbar = document.getElementById("Navbar");
      const isDesktop = !isMobileOrTabletDevice;
      if (currentScrollPos === 0) {
        Navbar.classList.remove("navbarTransition");
        setNavbar(false);
      } else {
        if (prevScrollPos > currentScrollPos) {
          setNavbar(true);
        } else {
          if (isDesktop) {
            setNavbar(true);
          } else {
            setNavbar(false);
            setShowRigVedQuotes(false);
            Navbar.classList.add("navbarTransition");
          }
        }
      }
      setNavbarExpanded(false);

      // const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
      // openDropdowns.forEach((dropdown) => {
      //   dropdown.classList.remove('show');
      // });

      prevScrollPos = currentScrollPos;
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isMobileOrTabletDevice]);
  const handleToggle = () => {
    // Check if the navbar is currently expanded
    if (navbarExpanded) {
      // If it is expanded, close it
      setNavbarExpanded(false);
    } else {
      // Otherwise, toggle it
      setNavbarExpanded(true);
    }
    // Close the RigVedQuotes whenever the navbar is toggled
    setShowRigVedQuotes(false);
  };

  // Function to handle RigVedQuote click
  const handleRigVedQuoteClick = () => {
    // Close the navbar and show RigVedQuotes if needed
    setNavbarExpanded(false);
    setShowRigVedQuotes(true);
  };

  // const toggleQuotesVisibility = () => {
  //   setShowRigVedQuotes((prevState) => !prevState);
  // };

  const closeRigved = () => {
    setShowRigVedQuotes(false);
  };
  const handleMouseEnter = () => {
    if (!isMobileOrTabletDevice) {
      setShowRigVedQuotes(true);
    }
  };
  const handleMouseLeave = () => {
    if (!isMobileOrTabletDevice) {
      setShowRigVedQuotes(false);
    }
  };
  const handleClickOutside = event => {
    // Check if the click is outside of both RigVedQuotes and navbar
    if (rigVedQuotesRef.current && !rigVedQuotesRef.current.contains(event.target) && navbarRef.current && !navbarRef.current.contains(event.target)) {
      setShowRigVedQuotes(false); // Only hide quotes
      setNavbarExpanded(false); // Collapse navbar
    }
  };
  (0, _react.useEffect)(() => {
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Navbar.default, {
    id: "Navbar",
    collapseOnSelect: true,
    expand: "lg",
    fixed: "top",
    variant: "dark",
    className: navbar ? "navbar active" : "navbar",
    expanded: navbarExpanded,
    ref: navbarRef // Attach ref to navbar
  }, /*#__PURE__*/_react.default.createElement(_Container.default, {
    className: "navbar-container"
  }, /*#__PURE__*/_react.default.createElement(_Navbar.default.Brand, {
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: links.brandURL,
    target: "_self",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: links.brandLogo,
    alt: links.brandName,
    className: "main_logo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "brandTagLineContainer",
    onClick: handleRigVedQuoteClick,
    onMouseOver: () => {
      if (!isMobileOrTabletDevice) {
        setShowRigVedQuotes(true);
        setNavbarExpanded(false); // Close the navbar when hovering over RigVedQuote
      }
    },
    onMouseOut: () => {
      if (!isMobileOrTabletDevice) {
        setShowRigVedQuotes(false);
      }
    },
    ref: rigVedQuotesRef // Attach ref to RigVedQuotes
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "brandTagLine"
  }, links.brandTagLine ? (0, _htmlReactParser.default)(String(links.brandTagLine)) : links.brandTagLine))), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement(RigVedQuotes, {
    rigvedaQuotePath: rigvedaQuotePath,
    showRigVedQuotes: showRigVedQuotes,
    closeRigved: closeRigved
  })), /*#__PURE__*/_react.default.createElement(_Navbar.default.Toggle, {
    "aria-controls": "responsive-navbar-nav",
    onClick: handleToggle
  }, navbarExpanded ? /*#__PURE__*/_react.default.createElement("span", {
    className: "close-icon"
  }, "x") // Close icon when expanded
  : /*#__PURE__*/_react.default.createElement("span", {
    className: "burger-icon"
  }, "\u2630") // Burger icon when collapsed
  ), /*#__PURE__*/_react.default.createElement(_Navbar.default.Collapse, {
    id: "responsive-navbar-nav"
  }, /*#__PURE__*/_react.default.createElement(_Nav.default, {
    className: "nav-right"
  }, menuItems.map(item => {
    if (item.id === "Ask Angel") {
      return /*#__PURE__*/_react.default.createElement(_Nav.default.Link, {
        key: item.id,
        href: item.url,
        target: isAngelAiDomain(item.url) ? "_self" : "_blank" // Open in new tab if not angelai.com
        ,
        className: "contact-us-btn largeScreen",
        id: "angel-ai-btn",
        rel: isAngelAiDomain(item.url) ? "" : "noopener noreferrer" // Add rel for security
      }, item.id);
    } else if (item.submenu) {
      return /*#__PURE__*/_react.default.createElement(_NavDropdown.default, {
        title: item.id,
        key: item.id,
        id: `nav-dropdown-${item.id}`,
        onMouseEnter: () => handleDropdownHover(item.id, true) // For desktop
        ,
        onMouseLeave: () => handleDropdownHover(item.id, false) // For desktop
        ,
        onClick: () => handleDropdownClick(item.id) // For mobile
        ,
        show: isMobileOrTabletDevice ? hoveredDropdown === item.id : hoveredDropdown === item.id
      }, renderSubMenu(item.submenu));
    } else {
      return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, {
        key: item.id,
        href: item.url,
        target: isAngelAiDomain(item.url) ? "_self" : "_blank" // Open in new tab if not angelai.com
        ,
        rel: isAngelAiDomain(item.url) ? "" : "noopener noreferrer" // Add rel for security
      }, item.id);
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "desktopaccesibility"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    color: IconColor,
    width: 35,
    height: 35,
    cdnPath: cdnBucketPath
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobileaccesibilty"
  }, /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    color: IconColor,
    width: 35,
    height: 35,
    cdnPath: cdnBucketPath
  }))));
};
var _default = exports.default = CommonHeader;